export const TIMES = [
  '12:00am',
  '12:30am',
  '1:00am',
  '1:30am',
  '2:00am',
  '2:30am',
  '3:00am',
  '3:30am',
  '4:00am',
  '4:30am',
  '5:00am',
  '5:30am',
  '6:00am',
  '6:30am',
  '7:00am',
  '7:30am',
  '8:00am',
  '8:30am',
  '9:00am',
  '9:30am',
  '10:00am',
  '10:30am',
  '11:00am',
  '11:30am',
  '12:00pm',
  '12:30pm',
  '1:00pm',
  '1:30pm',
  '2:00pm',
  '2:30pm',
  '3:00pm',
  '3:30pm',
  '4:00pm',
  '4:30pm',
  '5:00pm',
  '5:30pm',
  '6:00pm',
  '6:30pm',
  '7:00pm',
  '7:30pm',
  '8:00pm',
  '8:30pm',
  '9:00pm',
  '9:30pm',
  '10:00pm',
  '10:30pm',
  '11:00pm',
  '11:30pm',
]

export const CURRENCY_CODES = [
  {
    symbol: '$',
    name: 'US Dollar',
    symbol_native: '$',
    decimal_digits: 2,
    rounding: 0,
    code: 'USD',
    name_plural: 'US dollars',
    minimum: 0.5,
  },
  {
    symbol: 'AU$',
    name: 'Australian Dollar',
    symbol_native: '$',
    decimal_digits: 2,
    rounding: 0,
    code: 'AUD',
    name_plural: 'Australian dollars',
    minimum: 0.5,
  },
  {
    symbol: '£',
    name: 'British Pound Sterling',
    symbol_native: '£',
    decimal_digits: 2,
    rounding: 0,
    code: 'GBP',
    name_plural: 'British pounds sterling',
    minimum: 0.3,
  },
  {
    symbol: 'NZ$',
    name: 'New Zealand Dollar',
    symbol_native: '$',
    decimal_digits: 2,
    rounding: 0,
    code: 'NZD',
    name_plural: 'New Zealand dollars',
    minimum: 0.5,
  },
  {
    symbol: '€',
    name: 'Euro',
    symbol_native: '€',
    decimal_digits: 2,
    rounding: 0,
    code: 'EUR',
    name_plural: 'euros',
    minimum: 0.5,
  },
  {
    symbol: '¥',
    name: 'Japanese Yen',
    symbol_native: '￥',
    decimal_digits: 0,
    rounding: 0,
    code: 'JPY',
    name_plural: 'Japanese yen',
    minimum: 50,
  },
  {
    symbol: 'CHF',
    name: 'Swiss Franc',
    symbol_native: 'CHF',
    decimal_digits: 2,
    rounding: 0.05,
    code: 'CHF',
    name_plural: 'Swiss francs',
    minimum: 0.5,
  },
  {
    symbol: 'HK$',
    name: 'Hong Kong Dollar',
    symbol_native: '$',
    decimal_digits: 2,
    rounding: 0,
    code: 'HKD',
    name_plural: 'Hong Kong dollars',
    minimum: 1,
  },
]

export const companyCategoryTypes = () => [
  {
    name: 'Artist Manager',
    key: 'artistManager',
  },
  {
    name: 'Beer/Food/Wine/Winery Festivals',
    key: 'beerWineFestival',
  },
  {
    name: 'Concert Promoter',
    key: 'concertPromoter',
  },
  {
    name: 'Music Festivals',
    key: 'musicFestival',
  },
  {
    name: 'Sports Club/Team',
    key: 'sportsTeam',
  },
  {
    name: 'Venues',
    key: 'venue',
  },
  {
    name: 'Other',
    key: 'other',
  },
]

// RK: This is and all subsequent *CSVMap are functions
// because if I parse it as a variable, it
// injects them by reference.
export const initialEventsCSVMap = () => [
  {
    value: 'Event name',
    required: true,
    serverHeaderName: 'name',
    mappedTo: null,
    columnType: 'string',
    hint: null,
  },
  {
    value: 'Start Date & Time',
    serverHeaderName: 'startDate',
    mappedTo: null,
    required: true,
    columnType: 'datetime',
    hint: 'Recommended format DD/MM/YYYY HH:mm:ss',
  },
  {
    value: 'Timezone',
    required: true,
    mappedTo: undefined,
    hint: 'Applies to all events within this CSV import',
    columnType: 'string',
  },
  {
    value: 'End Date & Time',
    serverHeaderName: 'endDate',
    mappedTo: null,
    columnType: 'datetime',
    hint: 'Recommended format DD/MM/YYYY HH:mm:ss',
  },
  { value: 'Date Format', required: false, mappedTo: undefined, hint: 'Month-first (US) or day-first (International)', columnType: 'string' },
  {
    value: 'Event Description',
    serverHeaderName: 'description',
    mappedTo: null,
    columnType: 'string',
    hint: null,
  },
  {
    value: 'Venue',
    required: true,
    serverHeaderName: 'location',
    mappedTo: null,
    columnType: 'string',
    hint: null,
  },
  {
    value: 'Total ticket allocation quantity',
    serverHeaderName: 'capacity',
    mappedTo: null,
    columnType: 'number',
    hint: null,
  },
  {
    value: 'Event Image URL',
    serverHeaderName: 'imageUrl',
    mappedTo: null,
    columnType: 'string',
    hint: 'Must be a valid URL',
  },
  {
    value: 'Event ID',
    required: true,
    serverHeaderName: 'eventId',
    mappedTo: null,
    columnType: 'string',
    hint: null,
  },
  {
    value: 'Event URL',
    serverHeaderName: 'eventUrl',
    mappedTo: null,
    columnType: 'string',
    hint: 'Must be a valid URL',
  },
]

const emailAddressCSVField = labelKey => ({
  [labelKey]: 'Email',
  required: true,
  serverHeaderName: 'emailAddress',
  mappedTo: null,
  columnType: 'email',
  hint: 'Emails must be in the format example@provider.com',
})

const activeEmailCSVField = labelKey => ({
  [labelKey]: 'Active email',
  serverHeaderName: 'activeEmail',
  mappedTo: null,
  columnType: 'email',
  hint: 'Emails must be in the format example@provider.com',
})

const promoterExternalFanIdCSVField = labelKey => ({
  [labelKey]: 'Promoter external fan ID',
  required: true,
  serverHeaderName: 'promoterExternalFanId',
  mappedTo: null,
  columnType: 'string',
  hint: 'External ID for this contact in the promoter\'s system',
})

const contactIdentityCSVFields = (labelKey, useExternalIdAsPk = false) => useExternalIdAsPk
  ? [activeEmailCSVField(labelKey), promoterExternalFanIdCSVField(labelKey)]
  : [emailAddressCSVField(labelKey)]

export const initialAudienceCSVMap = ({ useExternalIdAsPk = false } = {}) => [
  ...contactIdentityCSVFields('value', useExternalIdAsPk),
  {
    value: 'First Name',
    serverHeaderName: 'firstName',
    mappedTo: null,
    columnType: 'string',
    hint: null,
  },
  {
    value: 'Last Name',
    serverHeaderName: 'lastName',
    mappedTo: null,
    columnType: 'string',
    hint: null,
  },
  { value: 'Street Address', serverHeaderName: 'streetAddress', mappedTo: null, hint: null, columnType: 'string' },
  { value: 'Suburb', serverHeaderName: 'city', mappedTo: null, hint: null, columnType: 'string' },
  { value: 'State', serverHeaderName: 'state', mappedTo: null, hint: null, columnType: 'string' },
  { value: 'Country', serverHeaderName: 'country', mappedTo: null, hint: null, columnType: 'string' },
  { value: 'Zip/post code', serverHeaderName: 'postcode', mappedTo: null, hint: null, columnType: 'string' },
  {
    value: 'Mobile',
    serverHeaderName: 'mobileNumber',
    mappedTo: null,
    columnType: 'mobileNumber',
    hint: 'Mobile numbers must include a country code and be between 1 and 14 digits. Recommended format +1555012345',
  },
  {
    value: 'Gender',
    serverHeaderName: 'gender',
    mappedTo: null,
    columnType: 'string',
    hint: null,
  },
  {
    value: 'Date of Birth',
    serverHeaderName: 'dob',
    mappedTo: null,
    columnType: 'datetime',
    hint: 'Recommended format DD/MM/YYYY',
  },
  { value: 'Date Format', required: false, mappedTo: undefined, hint: 'Month-first (US) or day-first (International)', columnType: 'string' },
  { value: 'Ticket Type', serverHeaderName: 'ticketClass', mappedTo: null, hint: null, columnType: 'string' },
  { value: 'Total Paid', required: true, serverHeaderName: 'totalRevenue', mappedTo: null, columnType: 'number', hint: 'Numbers and decimals only' },
  { value: 'Currency', required: true, mappedTo: undefined, hint: null, columnType: 'string' },
  {
    value: 'Quantity of Tickets',
    required: true,
    serverHeaderName: 'totalTickets',
    columnType: 'number',
    mappedTo: null,
    hint: null,
  },
  {
    value: 'Order Created Datetime',
    serverHeaderName: 'orderDate',
    mappedTo: null,
    columnType: 'datetime',
    hint: 'Recommended format DD/MM/YYYY HH:mm:ss',
  },
  { value: 'Timezone', required: true, mappedTo: undefined, hint: null, columnType: 'string' },
  { value: 'Order ID', required: true, serverHeaderName: 'orderId', mappedTo: null, hint: null, columnType: 'string' },
  { value: 'Discount Code Used', serverHeaderName: 'couponCode', mappedTo: null, hint: null, columnType: 'string' },
]

export const initialContactsCSVMap = ({ useExternalIdAsPk = false } = {}) => [
  ...contactIdentityCSVFields('name', useExternalIdAsPk),
  {
    name: 'First Name',
    serverHeaderName: 'firstName',
    mappedTo: null,
    columnType: 'string',
    hint: null,
  },
  {
    name: 'Last Name',
    serverHeaderName: 'lastName',
    mappedTo: null,
    columnType: 'string',
    hint: null,
  },
  {
    name: 'Gender',
    serverHeaderName: 'gender',
    mappedTo: null,
    columnType: 'string',
    hint: null,
  },
  { name: 'Street Address', serverHeaderName: 'streetAddress', mappedTo: null, hint: null, columnType: 'string' },
  { name: 'City', serverHeaderName: 'city', mappedTo: null, hint: null, columnType: 'string' },
  { name: 'State', serverHeaderName: 'state', mappedTo: null, hint: null, columnType: 'string' },
  { name: 'Country', serverHeaderName: 'country', mappedTo: null, hint: null, columnType: 'string' },
  { name: 'Zip/post code', serverHeaderName: 'postcode', mappedTo: null, hint: null, columnType: 'string' },
  {
    name: 'Date of Birth',
    serverHeaderName: 'dob',
    mappedTo: null,
    columnType: 'datetime',
    hint: 'Recommended format DD/MM/YYYY',
  },
  { name: 'Date Format', required: false, mappedTo: undefined, hint: 'Month-first (US) or day-first (International)', columnType: 'string' },
  {
    name: 'Phone Number',
    serverHeaderName: 'mobileNumber',
    mappedTo: null,
    columnType: 'mobileNumber',
    hint: 'Phone numbers must include a country code and be between 1 and 14 digits. Recommended format +1555012345',
  },
  {
    name: 'Tag',
    serverHeaderName: 'tag',
    mappedTo: null,
    columnType: 'string',
    hint: null,
  },
]

export const defaultTicketingProviders = () => [
  {
    key: 'default-ticketek',
    name: 'Ticketek',
    value: 'default-ticketek',
    defaultProvider: true,
    meta: {
      columnMap: {},
    },
    customMappings: [
      {
        value: 'Show ID',
        mappedTo: null,
        relatesTo: 'events',
        serverHeaderName: 'showId',
        required: true,
        error: null,
        enabledFor: ['events', 'events and orders'],
        hint: 'Ticketek events must include a Show ID',
        columnType: 'string',
      },
    ],
  },
]

export const initialPosCSVMap = () => [
  {
    value: 'POS line item ID',
    required: true,
    serverHeaderName: 'lineItemId',
    mappedTo: null,
    columnType: 'string',
    hint: 'The unique ID of each row. Rows cannot have the same line item ID',
  },
  // Order part
  {
    value: 'Order Created Datetime',
    serverHeaderName: 'orderDate',
    mappedTo: null,
    columnType: 'datetime',
    hint: 'Recommended format DD/MM/YYYY HH:mm:ss',
  },
  { value: 'Date Format', required: false, mappedTo: undefined, hint: 'Month-first (US) or day-first (International)', columnType: 'string' },
  {
    value: 'Timezone',
    required: true,
    mappedTo: undefined,
    hint: 'Applies to all events within this CSV import',
    columnType: 'string',
  },
  {
    value: 'Order ID',
    required: true,
    serverHeaderName: 'orderId',
    mappedTo: null,
    columnType: 'string',
    hint: 'The ID of the whole order. Rows can have the same order ID',
  },

  // product part
  {
    value: 'Product ID',
    required: true,
    serverHeaderName: 'productId',
    mappedTo: null,
    columnType: 'string',
    hint: 'The ID of the product type',
  },

  {
    value: 'Product Name/Title',
    required: true,
    serverHeaderName: 'product',
    mappedTo: null,
    columnType: 'string',
    hint: null,
  },

  {
    value: 'Quantity of items',
    required: true,
    serverHeaderName: 'quantity',
    columnType: 'string',
    mappedTo: null,
    hint: null,
  },

  { value: 'Total Paid', required: true, serverHeaderName: 'totalPaid', mappedTo: null, columnType: 'string', hint: 'Numbers and decimals only' },
  // currency mapped to undefined in order select from dropdown not in column mapping
  {
    value: 'Currency',
    required: true,
    mappedTo: undefined,
    hint: null,
    columnType: 'string' },

  // order discount part
  { value: 'Discount Code Used', serverHeaderName: 'discountCode', mappedTo: null, hint: null, columnType: 'string' },
  { value: 'Discount Percent', serverHeaderName: 'percent', mappedTo: null, columnType: 'string', hint: 'Numbers and decimals only' },
]

export const initialPosAudienceCSVMap = ({ useExternalIdAsPk = false } = {}) => [
  ...contactIdentityCSVFields('value', useExternalIdAsPk),
  {
    value: 'First Name',
    serverHeaderName: 'firstName',
    mappedTo: null,
    columnType: 'string',
    hint: null,
  },
  {
    value: 'Last Name',
    serverHeaderName: 'lastName',
    mappedTo: null,
    columnType: 'string',
    hint: null,
  },
  { value: 'Street Address', serverHeaderName: 'streetAddress', mappedTo: null, hint: null, columnType: 'string' },
  { value: 'City/Suburb', serverHeaderName: 'city', mappedTo: null, hint: null, columnType: 'string' },
  { value: 'State', serverHeaderName: 'state', mappedTo: null, hint: null, columnType: 'string' },
  { value: 'Country', serverHeaderName: 'country', mappedTo: null, hint: null, columnType: 'string' },
  { value: 'Zip/post code', serverHeaderName: 'postcode', mappedTo: null, hint: null, columnType: 'string' },
  {
    value: 'Mobile',
    serverHeaderName: 'mobileNumber',
    mappedTo: null,
    columnType: 'mobileNumber',
    hint: 'Mobile numbers must include a country code and be between 1 and 14 digits. Recommended format +1555012345',
  },
  {
    value: 'Gender',
    serverHeaderName: 'gender',
    mappedTo: null,
    columnType: 'string',
    hint: null,
  },
  {
    value: 'Date of Birth',
    serverHeaderName: 'dob',
    mappedTo: null,
    columnType: 'datetime',
    hint: 'Recommended format DD/MM/YYYY',
  },
  { value: 'Date Format', required: false, mappedTo: undefined, hint: 'Month-first (US) or day-first (International)', columnType: 'string' },
]

// default product provider shopify. Add more if needed
export const defaultProductProviders = () => [
  {
    key: 'default-product',
    name: 'Shopify',
    value: 'Shopify',
    defaultProvider: true,
    meta: {
      columnMap: {},
    },
  },
]

// protected csv assetType for s3 upload, mapping from import-type to the assetType
export const csvAssetType = {
  'audience-contact': 'import-audience-contact',
  'audience-sales': 'import-audience-sales',
  'audience': 'import-audience',
  'event': 'import-event',
  'event-and-audience': 'import-event-and-audience',
  'product-order': 'import-product-order',
}

// Reads runtime config, so it must be called from a Nuxt context (setup/plugin/composable),
// not at module load. process.env.arShortUrlDomain is undefined in the client bundle (EC-4685).
export const getArShortUrlPattern = () => `${useRuntimeConfig().public.arShortUrlDomain}/XXXXXX`
export const AR_DEV1_SHORT_URL_PATTERN = `https://dev1.arep.co/XXXXXX`
export const AR_STAGING_SHORT_URL_PATTERN = `https://staging.arep.co/XXXXXX`
export const AR_PROD_SHORT_URL_PATTERN = `https://arep.cc/XXXXXX`

export const MAX_CHARACTERS_SMS_MESSAGE = 1550
export const MAX_CHARACTERS_FACEBOOK_MESSAGE = 2000

export const dropdownTypeOptions = [
  { key: 'dropdown-single', display: 'Dropdown (single select)' },
  { key: 'dropdown-multi', display: 'Dropdown (multi select)' },
  { key: 'text', display: 'Plain text' },
  { key: 'date', display: 'Date' },
  { key: 'number', display: 'Number' },
]

// Ask `Intl` for a currency's symbol. CURRENCY_CODES holds eight codes, so it
// is not a usable symbol table on its own: a promoter selling in CAD, SGD or
// SEK misses it entirely. `Intl` knows every ISO 4217 code, and it is already
// what `formatCurrency` formats through — deriving both from it is what keeps
// one order from rendering two different symbols on two screens.
//
// Returns null for anything Intl rejects (not three ASCII letters), so callers
// can fall through. Note that a well-formed but unassigned code echoes itself
// ('ZZZ' -> 'ZZZ'), which is the honest rendering for an unknown currency.
const symbolFromIntl = function (code, display = 'narrowSymbol') {
  if (typeof code !== 'string') return null

  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: code,
      currencyDisplay: display,
    })
      .formatToParts(0)
      .find(part => part.type === 'currency')?.value || null
  }
  catch {
    // RangeError — not a well-formed currency code.
    return null
  }
}

export const getCurrencySymbol = function (currency, isNative = true) {
  const fromIntl = symbolFromIntl(currency, isNative ? 'narrowSymbol' : 'symbol')
  if (fromIntl) {
    return fromIntl
  }

  const selectedCurrency = CURRENCY_CODES.find((currency_code) => {
    return currency_code.code === currency
  })

  if (!selectedCurrency) {
    return '$'
  }

  if (isNative) {
    return selectedCurrency.symbol_native || '$'
  }
  else {
    return selectedCurrency.symbol || '$'
  }
}

// Stored money sometimes carries `currency` as an object ({ name: 'GBP' })
// rather than a plain code, because AM2's import modals persist the whole
// dropdown option. Normalize both shapes to a code string.
export const normalizeCurrencyCode = function (currency) {
  const fromObject = value => (value && (value.code || value.name)) || null

  const raw = (() => {
    if (!currency) return null
    if (typeof currency === 'object') return fromObject(currency)
    // Anything else truthy but not a string (a number, say) would throw on
    // .trim() below, from a computed that sits outside AM3Formatter's try.
    if (typeof currency !== 'string') return null
    // `currency_code` is a TEXT column, so an object-shaped currency reaches
    // the client already stringified: '{"name": "AUD"}'. Read it through the
    // same accessor as the object form, or '{"code":"GBP"}' would miss.
    if (currency.trim().charAt(0) === '{') {
      try {
        return fromObject(JSON.parse(currency))
      }
      catch {
        return null
      }
    }
    return currency
  })()

  // A stored 'gbp' or ' GBP ' should resolve: an ISO check of /^[A-Z]{3}$/ and
  // a CURRENCY_CODES lookup both fail otherwise, silently falling back.
  return typeof raw === 'string' ? (raw.trim().toUpperCase() || null) : raw
}

// Resolve an ISO currency code: the one carried on the value wins, then the
// promoter's region code, then undefined. Anything that is not ISO-shaped is
// discarded rather than passed on — `Intl.NumberFormat` throws a RangeError on
// an invalid code, and a caller catching that would render a raw number.
//
// Shares its precedence with resolveCurrencySymbol below so the code path and
// the symbol path cannot drift apart.
export const resolveCurrencyCode = function (currencyCode, fallbackCode) {
  const isIso = code => typeof code === 'string' && /^[A-Z]{3}$/.test(code)

  const code = normalizeCurrencyCode(currencyCode)
  if (isIso(code)) return code

  const fallback = normalizeCurrencyCode(fallbackCode)
  return isIso(fallback) ? fallback : undefined
}

// Resolve the symbol a money value should render with. Same precedence as
// resolveCurrencyCode: the currency carried on the value wins, then the
// promoter's region-settings symbol, then '$'.
//
// The value's own code is resolved through `Intl`, not CURRENCY_CODES. Off the
// eight-code table the difference is not cosmetic: a CAD order would fall
// through to the region's symbol and print a Canadian amount as '￥500.00'
// under a JPY region — the wrong currency on a real number, where the Orders
// tab formats the same order through `Intl` and correctly shows '$500.00'.
export const resolveCurrencySymbol = function (currencyCode, fallbackSymbol) {
  const code = resolveCurrencyCode(currencyCode, null)
  return (code && symbolFromIntl(code)) || fallbackSymbol || '$'
}
